/* HALE — gentle cart reminders:
   1) cart-icon pulse — ring centred on the icon;
   2) a persistent bar pinned to the top of the viewport with a free-shipping
      meter. Shown when the cart already holds 2+ items, OR this is the 2nd add
      of the session, OR the visit began with a non-empty cart. Follows across
      pages, ✕ closes it for the session, hidden on /cart and /checkout, and
      stands aside while any full-screen panel is open.

   Phase 1 (2026-09-08): a subscriber of the HALE cart store. The two
   monkey-patched window.fetch wrappers, the private /cart.js reads and the
   class-mutation observer are gone; state arrives on `hale:cart`, panels on
   `hale:layer`. Copy uses HALE.formatMoney (same output as hale-money.liquid). */
(function(){
  'use strict';
  var ADDS = 'hale_adds', BAR_CLOSED = 'hale_bar_closed';

  function ss(k){ try { return sessionStorage.getItem(k) === '1'; } catch(e){ return false; } }
  function mark(k){ try { sessionStorage.setItem(k, '1'); } catch(e){} }
  function adds(){ try { return parseInt(sessionStorage.getItem(ADDS), 10) || 0; } catch(e){ return 0; } }
  function bumpAdds(){ var n = adds() + 1; try { sessionStorage.setItem(ADDS, String(n)); } catch(e){} return n; }
  function isMobile(){ return window.matchMedia('(max-width:900px)').matches; }
  function onCartPage(){
    return /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:cart|checkout)(?:\/|$)/i.test(location.pathname);
  }

  var css = ''
  + '.hale a.cart{position:relative;}'
  + '.hale a.cart .icon-btn,.hale a.cart .mtab-ic{position:relative;z-index:1;}'
  + '.hale a.cart.hale-pulse .icon-btn,.hale a.cart.hale-pulse .mtab-ic{animation:haleBump .5s cubic-bezier(.22,.61,.36,1) 2;}'
  + '@keyframes haleBump{0%,100%{transform:scale(1);}45%{transform:scale(1.22);}}'
  + '.hale-ring{position:absolute;left:50%;top:50%;width:30px;height:30px;margin:-15px 0 0 -15px;border-radius:50%;'
    + 'border:2px solid var(--accent);opacity:.5;pointer-events:none;animation:haleRing .9s ease-out 2;}'
  + '@keyframes haleRing{0%{transform:scale(.55);opacity:.5;}100%{transform:scale(2.2);opacity:0;}}'
  + '.hale-cbar{position:fixed;left:0;right:0;top:0;z-index:var(--z-bar,190);color:#fff;'
    + 'background:color-mix(in srgb, var(--accent) 70%, #042c29);'
    + 'font-family:var(--sans);box-shadow:0 10px 30px -18px rgba(0,0,0,.5);'
    + 'transform:translateY(-100%);transition:transform .38s cubic-bezier(.22,.61,.36,1);}'
  + '.hale-cbar.on{transform:translateY(0);}'
  + '.hale-cbar-in{display:flex;align-items:center;gap:20px;max-width:1240px;margin:0 auto;padding:10px 20px;}'
  + '.hale-cbar-txt{display:none;}'
  + '.hale-cbar-ship{flex:1 1 auto;min-width:0;display:flex;flex-direction:column;gap:5px;}'
  + '.hale-cbar-ship span{font-size:11.5px;color:rgba(255,255,255,.85);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}'
  + '.hale-cbar-ship span em{font-style:normal;font-weight:600;color:#fff;}'
  + '.hale-cbar-bar{position:relative;height:5px;border-radius:20px;background:rgba(255,255,255,.22);overflow:hidden;}'
  + '.hale-cbar-bar i{position:absolute;left:0;top:0;bottom:0;width:0;border-radius:20px;background:var(--bg-3);transition:width .5s cubic-bezier(.22,.61,.36,1);}'
  + '.hale-cbar a.cbar-go{flex:0 0 auto;display:inline-flex;align-items:center;gap:7px;background:#fff;color:var(--ink);'
    + 'border-radius:30px;padding:9px 20px;font-family:var(--serif);text-transform:uppercase;'
    + 'letter-spacing:.07em;font-size:12px;text-decoration:none;transition:.2s;}'
  + '.hale-cbar a.cbar-go:hover{background:var(--bg-3);color:var(--ink);}'
  + '.hale-cbar button.cbar-x{flex:0 0 auto;background:none;border:none;color:rgba(255,255,255,.7);font-size:16px;'
    + 'line-height:1;cursor:pointer;padding:6px 2px;transition:.2s;}'
  + '.hale-cbar button.cbar-x:hover{color:#fff;}'
  + 'body.hale-cbar-pad{padding-top:var(--hale-cbar-h,52px);}'
  + '@media(max-width:900px){.hale-cbar-in{gap:12px;padding:10px 14px;}'
    + '.hale-cbar a.cbar-go{padding:8px 15px;font-size:11px;}}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  function pulse(){
    document.querySelectorAll('.hale a.cart').forEach(function(a){
      a.classList.remove('hale-pulse');
      void a.offsetWidth;
      a.classList.add('hale-pulse');
      var icon = a.querySelector('.icon-btn, .mtab-ic') || a;
      var ring = document.createElement('i');
      ring.className = 'hale-ring';
      var ar = a.getBoundingClientRect(), ir = icon.getBoundingClientRect();
      ring.style.left = (ir.left - ar.left + ir.width/2) + 'px';
      ring.style.top  = (ir.top  - ar.top  + ir.height/2) + 'px';
      a.appendChild(ring);
      setTimeout(function(){ a.classList.remove('hale-pulse'); ring.remove(); }, 2000);
    });
  }

  var barEl = null, standAside = false;
  var TRUCK = '<span class="cb-truck" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7">'
    + '<path d="M3 7h11v8H3zM14 10h4l3 3v2h-7z"/><circle cx="7" cy="17" r="1.6"/><circle cx="17" cy="17" r="1.6"/></svg></span>';

  function shipHTML(left){
    return left > 0
      ? TRUCK + '<span class="cb-head"><em>' + window.HALE.formatMoney(left) + '</em><i class="cb-tail">до безкоштовної доставки</i></span>'
      : TRUCK + '<span class="cb-head">Безкоштовна доставка</span>';
  }

  function buildBar(){
    if(barEl) return barEl;
    barEl = document.createElement('div');
    barEl.className = 'hale-cbar';
    barEl.innerHTML =
      '<div class="hale-cbar-in">'
      + '<div class="hale-cbar-txt" data-cb-txt hidden></div>'
      + '<div class="hale-cbar-ship"><span data-cb-msg data-cb-final="1"></span>'
        + '<div class="hale-cbar-bar"><i data-cb-bar></i></div></div>'
      /* 2026-09-16, власник: «Оформити» веде одразу в чекаут, без сторінки кошика.
         Посилання на /cart/checkout перехоплює chekly-script.js (селектор
         a[href*="/checkout"], reInit через MutationObserver) і відкриває чекаут
         Chekly — так само, як кнопка в шухляді кошика. */
      + '<a class="cbar-go" href="' + ((window.HALE.routes && window.HALE.routes.cart) || '/cart') + '/checkout">Оформити →</a>'
      + '<button class="cbar-x" type="button" aria-label="Закрити">✕</button>'
      + '</div>';
    document.body.appendChild(barEl);
    barEl.querySelector('.cbar-x').addEventListener('click', function(){ mark(BAR_CLOSED); hideBar(); });
    return barEl;
  }

  function paintBar(c){
    if(!barEl || !c) return;
    var H = window.HALE;
    var m = barEl.querySelector('[data-cb-msg]'), b = barEl.querySelector('[data-cb-bar]');
    var left = H.freeShip - c.items_subtotal_price;
    if(m){ var out = shipHTML(left); if(m.innerHTML !== out) m.innerHTML = out; }
    if(b) b.style.width = Math.min(100, c.items_subtotal_price / H.freeShip * 100) + '%';
  }

  function reveal(){ if(!barEl) return; barEl.classList.add('on'); document.body.classList.add('hale-cbar-pad'); }
  function hideBar(){ if(!barEl) return; barEl.classList.remove('on'); document.body.classList.remove('hale-cbar-pad'); }
  function shown(){ return !!(barEl && barEl.classList.contains('on')); }

  function due(c){
    var H = window.HALE;
    if(!c || c.item_count < 1) return false;
    if(H.visitStartedFull()) return true;
    return adds() >= 2 || H.cartCount(c) >= 2;
  }

  function showBar(c){
    if(ss(BAR_CLOSED) || onCartPage()) return;
    if(!due(c)) return;
    buildBar(); paintBar(c);
    if(isMobile() && !window.HALE.layers.isEmpty()){ standAside = true; return; }
    requestAnimationFrame(reveal);
    setTimeout(reveal, 80);
  }

  window.HALE.ready(function(){
    var H = window.HALE;
    H.on('hale:cart', function(e){
      var d = e.detail, c = d.cart;
      if(d.reason === 'add'){ bumpAdds(); pulse(); }
      if(c.item_count === 0){ hideBar(); return; }
      if(shown()) paintBar(c); else showBar(c);
    });
    /* stand aside while a full-screen panel is open on mobile; come back after */
    H.on('hale:layer', function(e){
      if(!isMobile()) return;
      if(e.detail.count > 0){ if(shown()){ standAside = true; hideBar(); } }
      else if(standAside){ standAside = false; showBar(H.cart.get()); }
    });
    window.addEventListener('resize', function(){ if(shown()) document.body.classList.add('hale-cbar-pad'); });
    showBar(H.cart.get());
  });
})();